/**
 * Created by root on 8/30/15.
 */

// Review this - check the ModelPaths removal.

define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var lpBaseListController = require('web-agent-assets-js/lpBaseListController');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    /* --------------------------------- Statics --------------------------------- */

    var TABLE_FILTERS = {
        conversationStates: conversationStatesFilter,
        sla_duration: slaDurationFilter
    };

    var BASE = lpBaseListController;

    /* --------------------------------- Constructor --------------------------------- */

    var lpBaseConnectionListController = BASE.extend(function BaseConnectionListController(options) {
        /**
         * holds the current subscription if for the table.
         * @type {null}
         */
        this.subscription = {};

        /**
         * a flag indicating the state of the data in the model, if true, the UI data is not sync with the data, and need a refresh.
         * @type {boolean}
         */
        this.isDirty = false;

        // binding the "Data" model path to get changes in the data to propagate to the UI
        this.model.bind(this.getModelPaths().isDirty, onDataChange.bind(this));

        //bind for AMS socket connected

        this.model.bind(lpAMSController.MODEL_PATHS.socketState, this.onSocketConnectionChanged, this);

        function onDataChange(data) {
            if (data && data.hasOwnProperty('newValue')) {
                this.isDirty = data.newValue;
            }
        }
    });


    /* --------------------------------- Overrides --------------------------------- */

    lpBaseConnectionListController.prototype.applicationType = 'lpBaseConnectionListController';
    lpBaseConnectionListController.staticSettings = {
        poolingInterval: 1000
    };

    lpBaseConnectionListController.prototype.updateSubscription = function (query) {
        // if we are not connected to the AMS we are not asking for the subscription, the next time that the connection will recover
        // the "connected" state will trigger the update.
        if (!lpTag.WebAgent.logicController.isAmsConnectionStatusActive()) {
            this.subscription = {};
            return;
        }

        // if we are in the process of creating a new subscription, we skip this update.
        if (this.subscription.state === lpBaseListController.STATES.FETCHING) {
            return;
        }

        // switching the query and setting the subscription update state.
        this.subscription.state = lpBaseListController.STATES.FETCHING;
        this.subscription.query = query;

        // un-subscribe from the the old subscription
        if (this.subscription.subscriptionId) {
            lpTag.WebAgent.amsSubscriptionsController.unsubscribe(this.subscription.subscriptionId, true);
        }

        // creating the subscription - asking it from the AMS.
        lpTag.WebAgent.amsSubscriptionsController.subscribe(this.subscription.query, {
                modelPath: this.getModelPaths().data,
                isDirtyModelPath: this.getModelPaths().isDirty,
                conversationPostProcessHandlers: _getSubscriptionHandlers(),
                trackActiveConversations: true
            },
            (function (err, result) {
                if (err) {
                    this.subscription.subscriptionId = null;
                    this.subscription.state = lpBaseListController.STATES.ERROR;
                    return;
                }
                this.subscription.subscriptionId = result.subscriptionId;
                this.subscription.state = lpBaseListController.STATES.FETCHED;
                this.fetch(true);
            }).bind(this)
        );

        function _getSubscriptionHandlers() {
            var conversationPostProcessHandlers = {};
            conversationPostProcessHandlers[lpAMSController.NOTIFICATION_TYPES.UPSERT] = function (conversationData) {
                lpTag.WebAgent.amsConversationController.updateChatModelByConversation(conversationData);
                lpTag.WebAgent.amsConversationController.bindReadersToEngagements(conversationData);
            };
            conversationPostProcessHandlers[lpAMSController.NOTIFICATION_TYPES.DELETE] = function (conversationData) {
                lpTag.WebAgent.amsConversationController.updateChatModelByConversation(conversationData);
                lpTag.WebAgent.amsConversationController.unbindReadersToEngagements(conversationData);
            };
            return conversationPostProcessHandlers;
        }
    };

    /**
     * translate the UI filters into subscription filters.
     */
    lpBaseConnectionListController.prototype.getSubscriptionQuery = function () {
        var subscriptionQuery = {
                brandId: this.model.get('account'),
                convState: [lpAMSController.CONVERSATION_STATES.OPEN]
            },
            subscribeOnlyMyConnection = agentLEManager.getAccountSettingValueByIdLE('le.agent.messaging.AgentManagerSubscribeToMyConversationsOnly') === 'true',
            viewAllChatsPrivilage = privilegesController.hasViewAllChatsPrivilege(),
            hasAgentManagerPrivilage = privilegesController.hasAgentManagerModulePrivilege();


        //If an unauthorised agent is requesting this or agent with le.agent.messaging.AgentManagerSubscribeToMyConversationsOnly setting on, limit the search to "my conversations"
        if (subscribeOnlyMyConnection || (!viewAllChatsPrivilage && !hasAgentManagerPrivilage)) {
            subscriptionQuery.agentIds = [this.model.get('agent.messagingUserId')];
        }
        else if (this.lastQuery && this.lastQuery.agentIds) {
            subscriptionQuery.agentIds = _getFormattedIds(this.lastQuery.agentIds, subscriptionQuery.brandId);
        }

        if (this.lastQuery && this.lastQuery.groupIds) {
            subscriptionQuery.groupIds = _getFormattedIds(this.lastQuery.groupIds);
        }

        if (this.lastQuery && this.lastQuery.conversationStates) {
            subscriptionQuery.convState = _getConvState(this.lastQuery.conversationStates);
        }

        return subscriptionQuery;

        // returns the conversation state according to filter requirements
        function _getConvState(requestData) {
            var finalConvState = [];

            if (requestData && requestData.selectedItems && requestData.selectedItems.length > 0) {
                var convStateRaw;
                convStateRaw = requestData.selectedItems.split(',');

                var badgesEnum = lpAMSController.BADGES;
                var conversationStatesEnum = lpAMSController.CONVERSATION_STATES;
                //don't allow these states as they are not supported -[OVERDUE,URGENT,FIRST_TIME,IN_QUEUE]
                //also, if we're filtering for closed, add locked as well
                if (convStateRaw.indexOf(badgesEnum.OVERDUE) >= 0 || convStateRaw.indexOf(badgesEnum.URGENT) >= 0 || convStateRaw.indexOf(badgesEnum.FIRST_TIME) >= 0 || convStateRaw.indexOf(badgesEnum.IN_QUEUE) >= 0 || convStateRaw.indexOf(conversationStatesEnum.OPEN) >= 0) {
                    finalConvState.push(conversationStatesEnum.OPEN);
                }
                if (convStateRaw.indexOf(conversationStatesEnum.CLOSE) >= 0) {
                    finalConvState.push(conversationStatesEnum.LOCKED);
                    finalConvState.push(conversationStatesEnum.CLOSE);
                }
                if (finalConvState === []) {
                    finalConvState = [""]; //empty as backup will filter by nothing and show everything
                }
            }
            return finalConvState;
        }

        /**
         * Return Array of ids with desired format
         * @param {String} ids in the form of id1,id2
         * @param {String=} brandId
         * @returns {Array}
         * @private
         */
        function _getFormattedIds(ids, brandId) {
            var idsList = ids.split(",");
            if(!brandId) {
                return idsList;
            }
            //the server expects the agent id as we know it to be with account id before it
            idsList = idsList.map(function(obj){
                return (brandId + "." + obj);
            });
            return idsList ;
        }
    };


    lpBaseConnectionListController.prototype.fetch = function (forceFetch) {
        // validating the need for subscription change in the server
        var query = this.getSubscriptionQuery();
        if (typeof this.subscription.query === 'undefined' || !_.isEqual(query, this.subscription.query)) {
            markDirtyFlag(this, false);
            this.updateSubscription(query);
            return;
        }

        var result = [];
        var totalResultsCount;
        var modelPath = lpAMSController.MODEL_PATHS.connectionsListModelLocations;
        var data = getListData.call(this, modelPath.data);

        var oldState = this.model.get(modelPath.state);

        if (forceFetch || !oldState || !oldState.status || oldState.status === lpBaseListController.STATES.ERROR) {
            this.setState(lpBaseListController.STATES.FETCHING);
        }

        // if the data is not defined yet, it's not on the model,
        // we kill the fetch at "Fetching" state until the initial set of data.
        if (!data) {
            return;
        }

        var conversationList = lpUtils.cloneObject(data) || {};

        //there are no conversations to show
        if (!conversationList || (typeof conversationList === "object" && !lpUtils.objectKeysCount(conversationList))) {
            this.setState(lpBaseListController.STATES.FETCHED, "ok", result.length);
            this.model.set(lpAMSController.MODEL_PATHS.connectionsListModelLocations.array, result);
            markDirtyFlag(this, false);
            return;
        }

        var instructions = getInstruction(this.lastQuery, this.settings);

        result = filterList(conversationList, instructions);
        sortList(result, instructions.sortTag, instructions.sortOrder);
        totalResultsCount = result.length;
        // paginate
        result = result.slice(instructions.skip, instructions.skip + instructions.limit);
        result = _.map(result, function (conversationObj) {
            return modelConversationObject.call(this, conversationObj);
        }, this);

        this.setState(lpBaseListController.STATES.FETCHED, "ok", result.length);
        this.model.set(modelPath.array, result);

        if (modelPath.count) {
            this.model.set(modelPath.count, totalResultsCount);
        }
        markDirtyFlag(this, false);
    };

    // Overriding the Pooling system to work with the "isDirty" flag to indicate that we have stale data.
    lpBaseConnectionListController.prototype.startPolling = function () {
        var self = this;
        if (!this.isPolling()) {
            this.fetch();
            this.poolingIntervalRef = setInterval(conditionalFetch.bind(this), this.settings.poolingInterval || lpBaseConnectionListController.staticSettings.poolingInterval);
        }

        function conditionalFetch() {
            if (self.isDirty) {
                self.fetch();
            }
        }
    };

    lpBaseConnectionListController.prototype.getModelPaths = function () {
        return lpAMSController.MODEL_PATHS.connectionsListModelLocations;
    };

    lpBaseConnectionListController.prototype.onSocketConnectionChanged = function (data) {
        if (data && data.newValue === "connected") {
            this.model.bind('agent.messagingUserId', onAMSReady, this);
        }

        function onAMSReady() {
            this.updateSubscription(this.getSubscriptionQuery());
            this.model.unbind('agent.messagingUserId', onAMSReady, this);
        }
    };

    lpBaseConnectionListController.prototype.openConversation = function (conversationInfo) {
        if (!lpTag.WebAgent.logicController.isInMyEngagements(conversationInfo.convId)) {
            lpTag.WebAgent.amsConversationController.openEngagement({chatId: conversationInfo.convId});
        }
        var consumerId = _getConsumerId(conversationInfo);
        if (consumerId) {
            window.App.viewEventsHandler.fireEvent({
                appName: consumerId,
                UIEvent: window.App.viewEventsHandler.eventType.VISITOR_FOCUSED
            });
        }
    };

    function _getConsumerId(conversationInfo) {
        // the consumer ID can be in different locations, if the API is V1 or V2
        return conversationInfo.consumerId || (conversationInfo.consumerProfile && conversationInfo.consumerProfile.userId);
    }

    function getListData(dataPath) {
        var consumerConversations;
        var result = {};
        var data = this.model.get(dataPath);
        if (!data) {
            return data;
        }

        // Grouping by Consumer Id, if the consumer is is undefined, remove it from the list because it's not a valid
        // conversation.
        var conversationsByConsumer = _.groupBy(data, "consumerId");
        for (var consumerId in conversationsByConsumer) {

            // ignore no consumer id - this is invalid conversation.
            if (consumerId === 'undefined') {
                continue;
            }

            consumerConversations = conversationsByConsumer[consumerId];

            // if i have more then one conversation, i'm sorting it to get the latest conversation.
            if (consumerConversations.length > 1) {
                consumerConversations.sort(conversationSorter);
            }

            result[consumerConversations[0].convId] = consumerConversations[0];
        }

        return result;

        function conversationSorter(a, b) {
            return a.conversationDetails.startTs <= b.conversationDetails.startTs ? 1 : -1;
        }
    }

    /**
     * create an instruction's object based on the lastQuery from the table.
     * @param {Object} lastQuery - the query from the table.
     * @param {Object} settings - the settings of the controller.
     * @returns {{sortTag: *, sortOrder: (string|*|string), limit: (number|*), skip: *, filters: *}}
     */
    function getInstruction(lastQuery, settings) {
        var instructions = _.merge(lpUtils.cloneObject(settings.defaultSearchUIData), {
            sortTag: lastQuery.sortTag,
            sortOrder: lastQuery.sortOrder,
            limit: lastQuery.limit,
            skip: lastQuery.skip,
            filters: extractFilters()
        });


        return instructions;


        function extractFilters() {
            var filters = {};
            for (var item in lastQuery) {
                if (TABLE_FILTERS.hasOwnProperty(item)) {
                    filters[item] = lastQuery[item];
                }
            }
            return filters;
        }
    }

    function conversationStatesFilter(options, item) {
        var states = options.selectedItems.split(',');
        for (var i = 0; i < states.length; i++) {
            switch (states[i]) {
                case lpAMSController.CONVERSATION_STATES.OPEN:
                case lpAMSController.CONVERSATION_STATES.CLOSE:
                    if (hasState(states[i])) {
                        return true;
                    }
                    break;

                case lpAMSController.BADGES.FIRST_TIME:
                case lpAMSController.BADGES.URGENT:
                case lpAMSController.BADGES.OVERDUE:
                case lpAMSController.BADGES.IN_QUEUE:
                    if (hasBadge(states[i]) && hasState(lpAMSController.CONVERSATION_STATES.OPEN)) {
                        return true;
                    }
                    break;
                case lpAMSController.BADGES.IN_SURVEY: // when IN_SURVEY or NO_ACTIVE_DIALOG badge - filter item out from the list
                case lpAMSController.BADGES.NO_ACTIVE_DIALOG:
                    if (hasBadge(states[i])) {
                        return false;
                    }
                    break;
            }
        }
        return false;
        function hasState(key) {
            return item && item.conversationDetails.state && item.conversationDetails.state === key;
        }

        function hasBadge(key) {
            if (item && item.badges) {
                switch (key) {
                    case lpAMSController.BADGES.FIRST_TIME  :
                        return !!item.badges.first_time;
                    case lpAMSController.BADGES.URGENT      :
                        return !!item.badges.urgent;
                    case lpAMSController.BADGES.OVERDUE     :
                        return !!item.badges.overdue;
                    case lpAMSController.BADGES.IN_QUEUE     :
                        return !!item.badges.in_queue;
                    case lpAMSController.BADGES.IN_SURVEY:
                        return !!item.badges.in_survey;
                    case lpAMSController.BADGES.NO_ACTIVE_DIALOG:
                        return !!item.badges.no_active_dialog;

                }
            }
            return false;
        }

    }

    function slaDurationFilter(options, item) {
        var timeUnitsFactor = {
            minutes: 60,
            hours: 60 * 60,
            days: 60 * 60 * 24
        };

        if (typeof item.effectiveTTR === 'undefined' || item.effectiveTTR === -1) {
            return false;
        }

        var currentTime = lpTag.WebAgent.amsController.getServerTime();
        var timeFrame = timeUnitsFactor[options.durationUnit] * 1000;
        var ltTime = options.longerThan;
        var stTime = options.shorterThan;

        switch (options.comparisonMethod) {
            case "longer":
                return isLongerThen();
            case "between":
                return (isLongerThen() && isShorterThen());
            case "shorter":
                return isShorterThen();
        }

        function isLongerThen() {
            return item.effectiveTTR >= currentTime + (timeFrame * ltTime);
        }

        function isShorterThen() {
            return item.effectiveTTR <= currentTime + (timeFrame * stTime);
        }
    }

    /**
     * filter a list based on instructions containing filters.
     * @param {Object} list -  a hash object with items to filter.
     * @param {Object} instructions -  the instruction object containing the filters to apply.
     * @returns {Array} an array of items that matching the instructions
     */
    function filterList(list, instructions) {
        // iterate over each item in the array. run all the handlers to filter the data.
        var result = [];
        for (var lstItem in list) {
            var isFiltered = false;

            for (var filter in instructions.filters) {
                if (!TABLE_FILTERS[filter](instructions.filters[filter], list[lstItem])) {
                    isFiltered = true;
                }
            }

            if (!isFiltered) {
                // pass filtering.
                result.push(list[lstItem]);
            }
        }
        return result;
    }

    /**
     * sort an array based on a field and direction
     * @param {Array} arr - the array to sort
     * @param {String} field - the name of the field in the array item.
     * @param {String} direction - 'asc' | 'desc' for the direction.
     */
    function sortList(arr, field, direction) {

        /**
         * Secondary sorting:
         * in the UI we don't have the concept of secondary sorting, so it's hardcoded in all
         * of the sorting functions except itself.
         *
         * as determined in LE-71820, we will use the "Last Content Event Message Time" to apply the secondary sorting
         * in order to avoid the "Jumping" Records in the list, because the effect of the "Joined/Spectated"
         * modification to the conversation.
         */
        var SECONDARY_SORT_FUNC = lastMessageTimeCompare;

        var d = direction === 'asc' ? 1 : -1;

        var compareFn;
        switch (field) {
            case 'SLA':
                compareFn = slaCompare;
                break;
            case 'state':
                compareFn = stateCompare;
                break;
            case 'LastMessageTime':
                compareFn = lastMessageTimeCompare;
                break;
            case 'StartTime':
                compareFn = startTimeCompare;
                break;
            default :
                compareFn = lpUtils.getSortFunctionWithDirection(field, d);
        }

        // Apply secondary sorting is a compare function defined.
        if(SECONDARY_SORT_FUNC && compareFn !== SECONDARY_SORT_FUNC){
            compareFn = composeSecondarySorting(compareFn);
        }

        // if we have a compare function, sort the list by it.
        if (compareFn) {
            arr.sort(compareFn);
        }

        // Compose a new sorting method by combining the primary compare with the secondary compare.
        // TODO: NewUI: Add Enhanced Sorting Capabilities (SortBy,ThenBy) for a chain of sorting.
        function composeSecondarySorting(pCompare){
            return function (a,b){
                var cRes = pCompare.call(null, a,b);
                if(cRes === 0){
                    return SECONDARY_SORT_FUNC.call(null, a,b);
                }
                else {
                    return cRes;
                }
            };
        }

        /**
         * Comparer for state
         * @param a
         * @param b
         * @returns {number}
         */
        function stateCompare(a, b) {
            var aScore = getObjectScoring(a);
            var bScore = getObjectScoring(b);

            if (aScore === bScore) {
                return 0;
            } else if (aScore > bScore) {
                return -1 * d;
            } else {
                return d;
            }

            function getObjectScoring(o) {
                var score = 0;
                var badgesObj = o.badges;

                if (o.conversationDetails.state == 'OPEN') {
                    score = 1;

                    if (badgesObj.first_time) {
                        score += 2;
                    }
                    if (badgesObj.urgent) {
                        score += 4;
                    }
                    if (badgesObj.overdue) {
                        score += 8;
                    }
                    if (badgesObj.in_queue) {
                        score += 16;
                    }
                }
                return score;
            }
        }

        /**
         * Comparer for SLA (Inverted Compare)
         * @param a
         * @param b
         * @returns {number}
         */
        function slaCompare(a, b) {
            var aScore = getObjectScoring(a);
            var bScore = getObjectScoring(b);

            if (aScore === bScore) {
                return (b.effectiveTTR - a.effectiveTTR) * d;
            }
            else {
                return (aScore - bScore) * d;
            }

            function getObjectScoring(o) {
                var score = 0;
                if (o.effectiveTTR && o.effectiveTTR != -1) {
                    score += 2;
                }
                if (o.conversationDetails.state == 'OPEN') {
                    score += 1;
                }
                return score;
            }
        }

        /**
         * Basic Numeric compare for Last Content Event Sorting.
         * @param a {object} - conversation object
         * @param b {object} - conversation object
         * @returns {number} - (1,-1)
         */
        function lastMessageTimeCompare(a, b){
            var aLM = a && a.lastContentEventNotification && a.lastContentEventNotification.serverTimestamp;
            var bLM = b && b.lastContentEventNotification && b.lastContentEventNotification.serverTimestamp;

            return (aLM - bLM) * d;
        }

        /**
         * Basic Numeric compare for Conversation Start Time Sorting.
         * @param a {object} - conversation object
         * @param b {object} - conversation object
         * @returns {number} - (1,-1)
         */
        function startTimeCompare(a, b){
            var aST = a && a.conversationDetails && a.conversationDetails.startTs;
            var bST = b && b.conversationDetails && b.conversationDetails.startTs;

            return (aST - bST) * d;
        }

    }


    /**
     * Map's the conversation object into a conversation list object for the data table.
     * @param conversation
     */
    function modelConversationObject(conversation) {
        // will translate the conversation object into a table result object
        // notice, all profiles are resolved at this state and it's safe to get them from the model.
        var result = {
            convId: conversation.convId,
            state: conversation.conversationDetails.state,
            closeReason: conversation.conversationDetails.closeReason,
            badges: conversation.badges,
            responseTime: {
                effectiveTTR: conversation.effectiveTTR,
                SlaTexts: conversation.SlaTexts
            },
            consumerProfile: getProfile.call(this, conversation.consumerId),
            assignedAgentProfile: getProfile.call(this, conversation.assignedAgentId),
            skillId: conversation.conversationDetails.skillId,
            CSATRate: conversation.conversationDetails.csatRate,
            lastUpdateTime: conversation.lastUpdateTime,
            loggedInAgentUnreadCount: getUnreadCount.call(this, conversation, this.model.get('agent.messagingUserId')),
            lastContentEventNotification: conversation.lastContentEventNotification,
            startTime: conversation.conversationDetails.startTs,
            agentGroupId: conversation.conversationDetails.groupId,
            suggestedAgentId: conversation.suggestedAgentId,
            suggestedAgentProfile: getProfile.call(this, conversation.suggestedAgentId)
        };

        if (result.lastContentEventNotification && result.lastContentEventNotification.event && result.lastContentEventNotification.event.type === 'RichContentEvent') {
            result.lastContentEventNotification.event.contentType = lpAMSController.CONTENT_TYPES.RICH_CONTENT;
        }


        if (_.isFunction(this.extendConversation)) {
            result = _.merge(result, this.extendConversation.call(this, conversation));
        }

        return result;


        function getUnreadCount(conversation, agentId) {
            if (agentId) {
                if (conversation && conversation.conversationDetails.state === lpAMSController.CONVERSATION_STATES.OPEN &&
                    conversation.numberOfunreadMessages && conversation.numberOfunreadMessages.hasOwnProperty(agentId)) {
                    return +conversation.numberOfunreadMessages[agentId];
                } else {
                    return 0;
                }
            }
        }

        function getProfile(userId) {
            return this.model.get('userProfiles.' + userId);
        }

    }

    function markDirtyFlag(context, value) {
        context.isDirty = value;
        context.model.modify(context.getModelPaths().isDirty, context.isDirty);
    }

    return lpBaseConnectionListController;

});
